import { render, staticRenderFns } from "./StepSelection.vue?vue&type=template&id=10d67275&scoped=true&"
import script from "./StepSelection.vue?vue&type=script&lang=js&"
export * from "./StepSelection.vue?vue&type=script&lang=js&"
import style0 from "./StepSelection.vue?vue&type=style&index=0&id=10d67275&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d67275",
  null
  
)

export default component.exports